import type { Item } from "./items";
import type { Product } from "./products";

export enum TaskType {
  IN_MAINTENANCE = "in_maintenance",
  IN_RETRIEVAL = "in_retrieval",
  SENDING_TO_CUSTOMER = "sending_to_customer",
  DISPATCHED_TO_FIELD = "dispatched_to_field",
  DISPATCHED_TO_SECOND_PLANT = "dispatched_to_second_plant",
}

export enum TaskExportFormat {
  CSV = "csv",
  PDF = "pdf",
}

export enum TicketStatus {
  Requested = "todo",
  InProgress = "in_progress",
  Done = "done",
  ProblemTickets = "problem",
}

export enum TicketTask {
  IN_MAINTENANCE = "in_maintenance",
  IN_RETRIEVAL = "in_retrieval",
  SENDING_TO_CUSTOMER = "sending_to_customer",
  DISPATCHED_TO_FIELD = "dispatched_to_field",
  DISPATCHED_TO_SECOND_PLANT = "dispatched_to_second_plant",
}

export interface CreateTicketPayload {
  items?: number[];
  products?: number[];
  task: TaskType | "";
  deadline: string;
  notify_email?: string;
  person_in_charge?: string;
  problem_details?: string;
  export_format?: TaskExportFormat;
  customize_columns?: Record<string, string>;
  status: TicketStatus;
}

export interface Ticket {
  id: number;
  item_id: number;
  task: string;
  deadline: string;
  notify_email: string;
  person_in_charge: string;
  status: TicketStatus;
  problem_details: string | null;
  customize_columns: string[];
  created_at: string;
  updated_at: string;
  items?: Item[];
  products?: Product[];
}

export interface TicketAnalytics {
  statusCounts: Record<TicketStatus, number>;
  taskCounts: Record<TicketTask, number>;
}
